import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import Portal from '@mui/material/Portal';
import { removeModal, selectModals, selectPortals } from 'modules/shared/stores/portals-slice-handler';
import { lazyImportComponent } from 'utils/functions';
import SimpleModal from './simple-modal';

/**
 * Render a portal using the options
 * @param {PortalOptions} portal
 */
const renderPortal = (portal) => {
    return (
        <Portal key={portal.id} container={portal.container}>
            {lazyImportComponent(portal)}
        </Portal>
    );
};

/**
 *
 * @param {WcfUiModalOptions} modalOptions
 */
const renderModal = (modalOptions) => {
    return (
        <SimpleModal
            key={modalOptions.uuid}
            dialogTitle={modalOptions.dialogTitle || ''}
            className={modalOptions.className || ''}
            closeCallback={() => {
                removeModal(modalOptions.uuid);

                if (typeof modalOptions.closeCallback === 'function') {
                    modalOptions.closeCallback();
                }
            }}
        >
            {lazyImportComponent(modalOptions)}
        </SimpleModal>
    );
};

function PortalsRenderer() {
    const portals = useSelector(selectPortals);
    const modals = useSelector(selectModals);

    return (
        <>
            {Object.keys(portals).map((portalId) => renderPortal(portals[portalId]))}
            {Object.keys(modals).map((modalId) => renderModal(modals[modalId]))}
        </>
    );
}

export default PortalsRenderer;
